<template>
  <div class="tab-content recharge-content">
    <template v-if="isLoggedIn">
      <div class="recharge-title-box">
        <h3>{{ t('rechargeTitle') }}</h3>
        <p class="sn-tip">{{ t('snCodeLabel') }}<span>{{ currentSn }}</span></p>
      </div>
      
      <div class="package-list">
        <div v-for="pkg in localizedPackageList" :key="pkg.id" class="package-card">
          <div class="pkg-left-badge">
            <span class="days-tag">{{ pkg.daysTag }}</span>
            <div class="data-amount">{{ pkg.data }}</div>
            <div class="pkg-footer-text">{{ pkg.periodText }}</div>
          </div>

          <div class="pkg-right-info">
            <div class="pkg-name">{{ pkg.name }}</div>
            <div class="pkg-action-row">
              <div class="pkg-price">
                <span class="currency-symbol">￥</span>
                <span class="num">{{ pkg.price }}</span>
              </div>
              <button class="buy-btn" @click="handleBuy(pkg)">{{ t('buyBtn') }}</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <Login :lang="lang" @login-success="onLoginSuccess" />
    </template>
  </div>
</template>

<script>
import Login from './Login.vue'
import i18nData from '@/i18n/locales.js'
import { packageList } from '@/data/packages.js'

export default {
  name: 'RechargeTab',
  components: { Login },
  props: {
    lang: { type: String, default: 'zh' },
    isLoggedIn: { type: Boolean, default: false },
    currentSn: { type: String, default: '' }
  },
  data() {
    return {
      packageList,
      i18n: i18nData
    }
  },
  computed: {
    localizedPackageList() {
      const isEn = this.lang === 'en'
      return this.packageList.map(pkg => ({
        ...pkg,
        name: isEn ? (pkg.nameEn || pkg.name) : (pkg.nameZh || pkg.name),
        daysTag: isEn ? (pkg.daysTagEn || pkg.daysTag) : (pkg.daysTagZh || pkg.daysTag),
        periodText: isEn ? (pkg.periodTextEn || pkg.periodText) : (pkg.periodTextZh || pkg.periodText)
      }))
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    },
    onLoginSuccess(sn) {
      this.$emit('login-success', sn)
    },
    handleBuy(pkg) {
      if (this.$message) {
        this.$message.info(`已选择套餐：${pkg.name}，需支付 ${pkg.price} 元`)
      }
    }
  }
}
</script>

<style scoped>
@import '../assets/styles/recharge.css';
</style>